var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[(_vm.path && _vm.path === '/login')?_c('layout-auth'):_vm._e(),(_vm.path && _vm.path !== '/login')?_c('layout-main'):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }